<div class="card">
    <div class="card-header">
        ESS Login Initiation
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Type:</label>
            </div>
            <div class="col px-1">
                <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Front"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Front
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Back"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Back
                </label>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Branch:</label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1" *ngIf="EmployeeType === 'Front'">
            <div class="col-md-2 px-1">
                <label class="Label">Client:</label>
            </div>
            <div class="col-md-7 px-1">
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1" *ngIf="EmployeeType === 'Front'">
            <div class="col-md-2 px-1">
                <label class="Label">Site:</label>
            </div>
            <div class="col-md-7 px-1">
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site');">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Code:</label>
            </div>
            <div class="col-md-2 px-1">
                <input name="Employeecode" type="text" [(ngModel)]="EmployeeCode" class="form-control" />
            </div>
            <div class="col-md-2 px-1">
                <button class="btn btn-sm btn-primary" name="submit" (click)="Load()">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">
                                    <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px;"
                                        name="header" type="checkbox" value="" />
                                </th>
                                <th scope="col">Employee Master ID</th>
                                <th scope="col">Employee Code</th>
                                <th scope="col">Employee Name</th>
                                <th scope="col">Branch Master ID</th>
                                <th scope="col">Branch</th>
                                <th scope="col" *ngIf="EmployeeType === 'Front'">Client Group Master ID</th>
                                <th scope="col" *ngIf="EmployeeType === 'Front'">Client Group </th>
                                <th scope="col" *ngIf="EmployeeType === 'Front'">Site Master ID
                                </th>
                                <th scope="col" *ngIf="EmployeeType === 'Front'">Site</th>
                                <th scope="col">Phone No.</th>
                                <th scope="col">Email</th>
                                <th scope="col">Password</th>
                            </tr>
                        </thead>
                        <tbody>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="submit" (click)="Save()">
                    <i class="bi bi-envelope-check-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Initiation':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>